e4.cart = {
    init: function () {
        if ( jQuery( '.js-e-cart-form' ).length === 1 ) {
            e4.util.require.js( e4.settings.require.handlebars, function () {
                e4.handlebars.registerHelpers( 'compare' );
                e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-cart-orderlines #js-e-handlebars-tmpl-order-summery' );
                // ATTENTION: Please note that all product-add/remove events are trigger on jQuery( document ) and not
                // the cart element.
                e4.cart.event = e4.util.registerEvents( 'load loaded update updated methodsupdate methodsupdated productadd productadded productremove productremoved orderlinedelete orderlinedeleted orderlineincrease orderlinedecrease', 'cart' );
                e4.cart.bindEvents();
                e4.cart.orderline.init();
                e4.cart.load();
            } );
        }
        else if ( jQuery( '.js-e-cart-quantity' ).length > 0 ) {
            e4.cart.event = e4.util.registerEvents( 'productadd productadded productremove productremoved', 'cart' );
            e4.cart.updateQuantity();
            e4.cart.msg.init();
        }
    },
    bindEvents: function () {
        jQuery( '.js-e-cart-form' ).on( 'submit', function ( event ) {
            event.preventDefault();
        } );
    },
    ajax: function ( objAjaxSettings, fnCallback ) {
        var jqXHR = jQuery.ajax( jQuery.extend( {
            url: e4.settings.ecom.cart.url,
            method: 'POST',
            dataType: 'json',
            cache: false
        }, objAjaxSettings ) );
        jqXHR.done( function ( data ) {
            if ( typeof fnCallback === 'function' ) {
                fnCallback( data );
            }
        } );
    },
    load: function () {
        var jCart = jQuery( '.js-e-cart' );
        jCart.trigger( e4.cart.event.load );
        e4.cart.ajax( {
            beforeSend: function () {
                jCart.find( '.js-e-loading-overlay' ).addClass( 'is-loading' );
            },
            data: jQuery( '.js-e-cart-form' ).serialize()
        }, function ( data ) {
            e4.cart.updateContent( data );
            jCart.trigger( e4.cart.event.loaded );
        } );
    },
    addProduct: function ( objProductFormData, fnCallback ) {
        var jDocument = jQuery( document ),
            jCart = jDocument.find( '.js-e-cart' );
        var objProductData = {
            CartCmd: 'add',
            ProductID: '',
            VariantID: '',
            Quantity: 1,
            Redirect: false
        };
        if ( jQuery.isPlainObject( objProductFormData ) ) {
            jQuery.extend( objProductData, objProductFormData );
        }
        else if ( jQuery.type( objProductFormData ) === 'string' ) {
            objProductData.ProductID = objProductFormData;
        }
        jDocument.trigger( e4.cart.event.productadd, objProductData );
        if ( objProductData.ProductID.indexOf( 'PROD' ) === 0 ) {
            e4.cart.ajax( {
                data: objProductData,
                beforeSend: function () {
                    if ( jCart.length === 1 ) {
                        jCart.find( '.js-e-loading-overlay' ).addClass( 'is-loading' );
                    }
                }
            }, function ( data ) {
                if ( jCart.length === 1 ) {
                    e4.cart.updateContent( data );
                    jCart.find( '.js-e-loading-overlay' ).removeClass( 'is-loading' );
                    e4.cart.orderline.setFocus( data.cart.lastAdded[ 0 ].id );
                }
                e4.cart.updateQuantity( data.cart.productQuantity );
                if ( typeof fnCallback === 'function' ) {
                    fnCallback( data );
                }
                jDocument.trigger( e4.cart.event.productadded, data );
            } );
        }
    },
    removeProduct: function () {
    },
    updateContent: function ( data ) {
        var jCart = jQuery( '.js-e-cart' );
        jCart.trigger( e4.cart.event.update );
        jQuery( '.js-e-cart-orderlines' ).html( e4.handlebars.tmpl.cartOrderlines( data ) );
        e4.loading.resolveWait( '.js-e-cart-orderlines' );
        jQuery( '.js-e-order-summery' ).html( e4.handlebars.tmpl.orderSummery( data ) );
        e4.loading.resolveWait( '.js-e-order-summery' );
        e4.cart.updateQuantity( data.cart.productQuantity );
        jCart.find( '.js-e-loading-overlay' ).removeClass( 'is-loading' );
        jCart.trigger( e4.cart.event.updated );
    },
    updateQuantity: function ( intQuantity ) {
        var jCartQuantity = jQuery( '.js-e-cart-quantity' );
        if ( jCartQuantity.length > 0 ) {
            if ( jQuery.isNumeric( intQuantity ) === false ) {
                e4.cart.ajax( {
                    method: 'GET'
                }, function ( data ) {
                    if ( jQuery.isNumeric( data.cart.productQuantity ) === true ) {
                        e4.cart.updateQuantity( data.cart.productQuantity );
                    }
                } );
            }
            else if ( intQuantity === 0 ) {
                jCartQuantity.empty();
            }
            else {
                jCartQuantity.html( intQuantity );
            }
        }
    },
    orderline: {
        init: function () {
            e4.cart.orderline.bindEvents();
        },
        bindEvents: function () {
            jQuery( '.js-e-cart-form' )
                .on( 'focus blur', '.js-e-orderline-quantity-input', e4.cart.orderline.toggleFocus )
                .on( 'input', '.js-e-orderline-quantity-input', e4.util.debounce( function ( event ) {
                    e4.cart.orderline.update( event.target );
                }, e4.settings.ecom.cart.debounceDelay ) )
                .on( 'click', '.js-e-orderline-update', function ( event ) {
                    event.preventDefault();
                    e4.cart.orderline.update( event.target );
                } )
                .on( 'click', '.js-e-orderline-delete-btn', function ( event ) {
                    event.preventDefault();
                    e4.cart.orderline.delete( event.target );
                } );
        },
        update: function ( domElm ) {
            var jOrderline = jQuery( domElm ).closest( '.js-e-orderline' ),
                intOrderlineQuantity = parseInt( jOrderline.find( '.js-e-orderline-quantity-input' ).val() );
            if ( intOrderlineQuantity !== 0 ) {

                var jForm = jOrderline.closest( '.js-e-cart-form' ),
                    jCart = jForm.closest( '.js-e-cart' ),
                    intOrderlineQuantityOriginal = parseInt( jOrderline.data( 'product-quantity' ) );
                if ( intOrderlineQuantity > intOrderlineQuantityOriginal ) {
                    jCart.trigger( e4.cart.event.orderlineincrease );
                }
                else if ( intOrderlineQuantity < intOrderlineQuantityOriginal ) {
                    jCart.trigger( e4.cart.event.orderlinedecrease );
                }
                jForm.find( '.js-e-cart-form-cartcmd' ).val( 'updateorderlines' );
                e4.cart.ajax( {
                    data: jForm.serialize(),
                    beforeSend: function () {
                        jCart.find( '.js-e-loading-overlay' ).addClass( 'is-loading' );
                    }
                }, function ( data ) {
                    e4.cart.updateContent( data );
                    jCart.find( '.js-e-loading-overlay' ).removeClass( 'is-loading' );
                    e4.cart.orderline.setFocus( jOrderline.attr( 'id' ) );
                } );
            }
            // else {
                // TODO: Remove or change this.
                // e4.cart.orderline.delete( domElm );
            // }
        },
        delete: function ( domElm ) {
            var jCart = jQuery( '.js-e-cart' );
            jCart.trigger( e4.cart.event.orderlinedelete );
            e4.cart.ajax( {
                data: {
                    key: jQuery( domElm ).closest( '.js-e-orderline' ).attr( 'id' ),
                    CartCmd: 'delorderline',
                    Redirect: false
                }
            }, function ( data ) {
                e4.cart.updateContent( data );
                jCart.trigger( e4.cart.event.orderlinedeleted );
            } );
        },
        setFocus: function ( strIdentifier ) {
            var jOrderline = jQuery( '.js-e-orderline' ).filter( '#' + strIdentifier + ',[data-product-id="' + strIdentifier + '"]' );
            if ( jOrderline.length === 1 ) {
                jOrderline.find( '.js-e-orderline-quantity-input' ).focus();
            }
        },
        toggleFocus: function ( event ) {
            var jOrderline = jQuery( event.target ).closest( '.js-e-orderline' );
            if ( event.type === 'focusin' ) {
                jQuery( event.target ).select();
                jOrderline.addClass( 'has-focus' );
            }
            else {
                jOrderline.removeClass( 'has-focus' );
            }
        }
    },
    msg: {
        timeout: null,
        init: function () {
            if ( jQuery( '#js-e-cart-msg' ).length === 1 ) {
                e4.util.require.js( e4.settings.require.handlebars, function () {
                    e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-cart-msg-lastadded' );
                } );
                e4.cart.msg.bindEvents();
            }
        },
        bindEvents: function () {
            var jBody = jQuery( 'body' );
            jQuery( '#js-e-cart-msg' ).on( 'show.bs.modal', function () {
                jBody.addClass( 'modal-open-no-adjustment' );
            } ).on( 'hidden.bs.modal', function () {
                jBody.removeClass( 'modal-open-no-adjustment' );
            } ).on( 'click', function ( event ) {
                if ( jQuery( event.target ).is( '#js-e-cart-msg' ) === true ) {
                    e4.cart.msg.hide();
                }
            } ).find( '.modal-dialog' ).on( 'mouseenter', e4.cart.msg.clearTimeout ).on( 'mouseleave', e4.cart.msg.setTimeout );
            jQuery( document ).on( e4.cart.event.productadded, function ( event, data ) {
                e4.cart.msg.show( data );
            } );
        },
        show: function ( data ) {
            var jCartMsg = jQuery( '#js-e-cart-msg' );
            //TODO: Lav set content, header og footer funktioner.
            jCartMsg.find( '.js-e-cart-msg-content' ).html( e4.handlebars.tmpl.cartMsgLastadded( data ) );
            e4.cart.msg.clearTimeout();
            e4.cart.msg.setPosition();
            jCartMsg.modal( 'show' );
            e4.cart.msg.setTimeout();
        },
        hide: function () {
            e4.cart.msg.clearTimeout();
            jQuery( '#js-e-cart-msg' ).modal( 'hide' );
        },
        setPosition: function ( objPosition ) {
            var jCartMsgDialog = jQuery( '#js-e-cart-msg' ).find( '.modal-dialog' ),
                jHeader = jQuery( '.js-e-header' ),
                jNavItemCart = jHeader.find( '.js-e-nav' ).find( '.js-e-nav-item-cart' ).filter( ':visible' ).first(),
                objCartMsgPosition = objPosition || {},
                objCartMsgReferencePosition = {};
            if ( jCartMsgDialog.length === 1 ) {
                if ( jQuery.isEmptyObject( objCartMsgPosition ) === true ) {
                    if ( jNavItemCart.length === 1 ) {
                        objCartMsgReferencePosition = jNavItemCart.get( 0 ).getBoundingClientRect();
                        objCartMsgPosition = {
                            top: jHeader.hasClass( 'is-hidden' ) === true ? '' : Math.floor( objCartMsgReferencePosition.bottom ),
                            right: Math.floor( jQuery( window ).width() - objCartMsgReferencePosition.right ),
                            left: '',
                            maxWidth: ''
                        };
                    }
                    else {
                        objCartMsgPosition = {
                            top: 0,
                            right: 0,
                            left: 0,
                            maxWidth: '100%'
                        };
                    }
                }
            }
            jCartMsgDialog.css( objCartMsgPosition );
        },
        setTimeout: function () {
            e4.cart.msg.clearTimeout();
            e4.cart.msg.timeout = setTimeout( e4.cart.msg.hide, e4.settings.ecom.cart.msgHideDelay );
        },
        clearTimeout: function () {
            if ( e4.cart.msg.timeout ) {
                e4.cart.msg.timeout = clearTimeout( e4.cart.msg.timeout );
            }
        }
    }
};

